// extracted by mini-css-extract-plugin
export default {"selected-report-category-page":"SelectedReportCategoryPage_selected-report-category-page__Kg+yL","loader-wrapper":"SelectedReportCategoryPage_loader-wrapper__4+IbY"};